import { render, staticRenderFns } from "./sdkDoc.vue?vue&type=template&id=007e6cfa&scoped=true&"
import script from "./sdkDoc.vue?vue&type=script&lang=js&"
export * from "./sdkDoc.vue?vue&type=script&lang=js&"
import style0 from "./sdkDoc.vue?vue&type=style&index=0&id=007e6cfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007e6cfa",
  null
  
)

export default component.exports